import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../hooks";

import "../components/components.css";

const LandingPage = () => {
  const { isAuthenticated, login, loading } = useAuth();

  // Show loading spinner while determining auth state
  if (loading) {
    return (
      <div className="app-loading-container">
        <div className="app-loading-spinner" />
        <p className="app-loading-text">Checking authentication...</p>
      </div>
    );
  }

  // Redirect authenticated users to interactions immediately after loading completes
  if (isAuthenticated) {
    return <Navigate to="/interactions" replace />;
  }

  // Show improved landing page with manual sign-in button
  return (
    <div className="landing-container">
      <div className="landing-content">
        {/* Welcome text above logo */}
        <p className="landing-welcome-text">Welcome to</p>

        {/* PerfectServe Logo */}
        <div className="landing-logo-container">
          <img src="/perfectserve-logo.png" alt="PerfectServe Logo" className="landing-logo" />
        </div>

        <p className="landing-description">Clinical Communication & Collaboration Platform</p>

        {/* Sign in button */}
        <button type="button" onClick={login} className="landing-signin-button">
          Sign In
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
